import { theme } from '@sbv-clients/ui-shared';

import { useCallOffsReportGet } from '../../../../services/dashboard';
import Counter from '../counter';
import useCallOffsReportModal from './call-offs-modal';

interface CallOffsReportProps {
  departmentId: number;
  positionId: number;
  startDate: Date;
  endDate: Date;
}

const CallOffsReport = ({
  departmentId,
  positionId,
  startDate,
  endDate,
}: CallOffsReportProps) => {
  const { data } = useCallOffsReportGet(
    departmentId,
    positionId,
    startDate,
    endDate
  );
  const { openModal, modal } = useCallOffsReportModal(
    departmentId,
    positionId,
    startDate
  );

  return (
    <>
      <Counter
        title="Call Offs"
        counterValue={data?.calloffsCount ?? 0}
        onClick={openModal}
        backgroundColor={theme.custom!.callOffsBg}
      />
      {modal}
    </>
  );
};

export default CallOffsReport;
